// extracted by mini-css-extract-plugin
export default {"app":"LoadRecord2_app__KiUMy","btns":"LoadRecord2_btns__XT1kF"};